// extracted by mini-css-extract-plugin
export default {"page-header":"Header_page-header__IJKGs","title-wrapper":"Header_title-wrapper__sk6ta"};